module.exports = __webpack_public_path__ + "cc9fe2c2ee7200c365259f1230a73f9d.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/Weibo.svg
// module id = ZhQQ
// module chunks = 3